import axios from 'axios';
import { getFileFormData } from './helpers.js';

const form_header = {
  headers: {
    'Content-Type': 'multipart/form-data', // 파일 전송 시 필요한 헤더
  },
};

const langPrefix = () => {
  if (typeof T === 'undefined' || !T.lang) return '';
  const p = location.pathname;
  return p === `/${T.lang}` || p.startsWith(`/${T.lang}/`) ? `/${T.lang}` : '';
};

/**
 * @define 프론트 - pdf 파일 업로드 요청
 * @param {File} file
 * @return {Promise<PdfResCommit<PdfUploadResult> | PdfResRollback>}
 * */
export async function uploadPdfFile({ file }) {
  return (
    await axios.post(`${langPrefix()}/@api/pdf/upload/printing`, getFileFormData({ file }), form_header)
  ).data;
}

/**
 * @define 프론트 - pdf 메타데이터 조회 요청
 * @param {File} file
 * @return {Promise<PdfResCommit<PdfMetadata[]> | PdfResRollback>}
 * */
export async function getMetadataPdfFile({ file }) {
  return (await axios.post(`${langPrefix()}/@api/pdf/metadata`, getFileFormData({ file }), form_header)).data;
}

/**
 * @define 프론트 - pdf 사이즈 검증 요청
 * @param {File} [file] - PDF 파일 (file 또는 pdf_url 중 하나 필수)
 * @param {string} [pdf_url] - 이미 업로드된 PDF URL
 * @param {number} bp_id
 * @param {string} bo_name
 * @return {Promise<{ is_valid: boolean, issues: string[], actual_size, expected_size }>}
 */
export async function checkPdfSize({ file, pdf_url, bp_id, bo_name }) {
  if (file) {
    const formData = getFileFormData({ file });
    formData.append('bp_id', String(bp_id));
    formData.append('bo_name', bo_name);
    return (await axios.post(`${langPrefix()}/@api/pdf/check-size`, formData, form_header)).data;
  }
  return (await axios.post(`${langPrefix()}/@api/pdf/check-size`, { pdf_url, bp_id, bo_name })).data;
}
